var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizShortAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M22.842 14.84H1.158a.3862.3862 0 0 1-.386-.386V7.253c0-.213.173-.386.386-.386h21.683c.213 0 .386.173.386.386v7.201c0 .213-.172.386-.385.386z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.15,
    strokeMiterlimit: 10,
    d: "M6.601 16.708a.224.224 0 0 1-.223-.224v-1.739h.34v-.6h-.34v-1.739c0-.123.1-.224.223-.224h.477v-.6h-.477c-.201 0-.379.081-.523.202-.143-.121-.322-.202-.523-.202h-.476v.6h.477c.123 0 .224.101.224.224v1.739h-.342v.6h.341v1.739a.225.225 0 0 1-.224.224h-.61v.6h.61c.202 0 .38-.081.523-.202.143.121.321.202.523.202h.61v-.6h-.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    d: "M2.683 8.304v5.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizShortAnswer);
export default __webpack_public_path__ + "static/media/quiz_shortAnswer.96974e7e8144c3e5df4474278d6e6796.svg";
export { ForwardRef as ReactComponent };